import { useQuery } from '~/utils/rq';

export type S2SPartner = {
  id: number;
  name: string;
};

type S2SPartners = S2SPartner[];

type S2SPartnersResponse = {
  partners: S2SPartners;
};

type useFetchS2SPartnersProps = {
  isEnabled: boolean;
};

export const useFetchS2SPartners = ({
  isEnabled
}: useFetchS2SPartnersProps) => {
  const URL = '/admin/s2s-partners?channels=linear_tv';

  return useQuery<S2SPartnersResponse>(
    {
      queryKey: [URL],
      enabled: isEnabled
    },
    {
      method: 'get',
      url: URL
    }
  );
};
